import { Tooltip } from '@mui/material';
import React, { FC } from 'react';

import useIsMobile from '../../../../hooks/useIsMobile';
import translate from '../../../../i18n/translate';
import {
  AttachmentAction,
  AttachmentMode,
} from '../../../../models/attachment';

import * as Styled from './styled';

type Props = {
  actionPreview?: AttachmentAction;
  mode: AttachmentMode;
  name: string;
};

/**
 * Component that renders preview button for the attachment
 * or just file name
 *
 * @param props               Props passed to the component
 * @param props.actionPreview Preview action props
 * @param props.mode          In which mode to render the component
 * @param props.name          File name
 * @returns                   The component itself
 */
const PreviewSegment: FC<Props> = ({ actionPreview, mode, name }) => {
  const isMobile = useIsMobile();

  if ((isMobile && mode === 'feed') || actionPreview === undefined) {
    return <Styled.Title>{name}</Styled.Title>;
  }

  return (
    <Tooltip
      disableHoverListener={isMobile}
      placement="top"
      title={translate('FILE__PREVIEW')}
    >
      <Styled.ButtonPreview
        aria-label={translate('FILE__PREVIEW')}
        disabled={actionPreview.isInProgress}
        onClick={actionPreview.requestButtonClick}
      >
        <Styled.Title>{name}</Styled.Title>
      </Styled.ButtonPreview>
    </Tooltip>
  );
};

export default PreviewSegment;
